import { ETypeChamp } from '../../../z16pro/classes/typeChamp';
import { ViewContainerRef, ComponentFactoryResolver, Input, ViewChild, AfterViewInit, Component, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { TypeChamp } from '../../../z16pro/classes/typeChamp';

@Component({
    selector: 'app-dynamic-table',
    templateUrl: './dynamic-table.component.html',
    styleUrls: ['./dynamic-table.component.css']
})
export class DynamicTableComponent {

    @Input() type: TypeChamp; // InputType
    @Input() required: boolean;
    @Input() data: any;

    @Output() valueChanged: EventEmitter<boolean | string> = new EventEmitter();
    @Output() handleValidate: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('container', {read: ViewContainerRef}) container;

    componentRef: any;

    constructor(
        public viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver
    ) { }

    get isTableau(): boolean {
        return this.type.code === ETypeChamp.TABLEAU;
    }

}
